/* Bag page: +/- steppers and quantity edits submit the cart form (Shopify applies updates[] and reloads /cart). */
(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-cart-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      const page = form.closest('[data-cart-page]');
      let timer;
      const submitSoon = (delay) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (page) page.classList.add('is-busy');
          const btn = form.querySelector('[data-cart-update]');
          if (form.requestSubmit && btn) form.requestSubmit(btn);
          else form.submit();
        }, delay);
      };
      form.addEventListener('click', (e) => {
        const step = e.target.closest('[data-cart-step]');
        if (!step) return;
        e.preventDefault();
        const input = step.parentElement.querySelector('[data-cart-qty]');
        if (!input) return;
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.cartStep));
        submitSoon(450);
      });
      form.addEventListener('change', (e) => {
        if (e.target.matches('[data-cart-qty]')) submitSoon(250);
      });
      // Save the note without a full reload.
      const note = form.querySelector('[name="note"]');
      if (note && window.fetch) {
        let noteTimer;
        note.addEventListener('input', () => {
          clearTimeout(noteTimer);
          noteTimer = setTimeout(() => {
            const url = (window.Mello && window.Mello.routes && window.Mello.routes.cart) || '/cart';
            fetch(`${url}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: note.value }) }).catch(() => {});
          }, 500);
        });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
